import React from 'react';

import UserPassport from 'components/profile/UserPassport';
import { Opinion } from 'app/entity/opinion/opinionTypes';

const AuthorInfo = (props: { opinion: Opinion }) => {
  const { opinion } = props;

  return (
    <div className="flex flex-col gap-4">
      <p className="text-xs text-neutral-500 font-bold">ABOUT ME</p>
      <div className="flex flex-col gap-2">
        <UserPassport
          profile={opinion.user}
          createdAt={opinion.createdAt}
          updatedAt={opinion.updatedAt}
          credential={opinion.credential || opinion.user.defaultCredential}
        />
        <p className="text-neutral-500 ml-11 break-words">
          {opinion.user.description}
        </p>
      </div>
    </div>
  );
};

export default AuthorInfo;
